import {observer} from "mobx-react";
import {Box, Link, Toolbar, Typography} from "@mui/material";
import piginiAnniversary from "../../assets/img/pigini_Anniversary.jpeg";
import React from "react";
import {useStore} from "../../stores/Store";
import Grid from "@mui/material/Unstable_Grid2";

export default observer(function Footer(){
    const {LanguageStore} = useStore();

    return(
        <Toolbar sx={{pb: 4, pt: 4, backgroundColor: theme => theme.palette.secondary.main}}>
            <Grid container rowSpacing={6} sx={{width: '100%'}}>
                <Grid xs={12} sm={4} >
                    <Box sx={{textAlign: 'center'}}>
                            <Typography variant={'subtitle2'} >
                                {(LanguageStore.currentLanguage === 'ru') ? null : <>{LanguageStore.currentLanguageMessages.Footer.firm}<br /></>}
                                {LanguageStore.currentLanguageMessages.Footer.addressLineOne} <br />
                                {LanguageStore.currentLanguageMessages.Footer.addressLineTwo} <br />
                                {LanguageStore.currentLanguageMessages.Footer.addressLineThree} <br />
                                {LanguageStore.currentLanguageMessages.Footer.address} <br />
                                {LanguageStore.currentLanguageMessages.Footer.plz} {LanguageStore.currentLanguageMessages.Footer.city} <br />
                            </Typography>
                    </Box>
                </Grid>
                <Grid xs={12} sm={4}>
                    <Box sx={{textAlign: 'center',}}>
                        <img src={piginiAnniversary} style={{width: '130px', borderRadius: '20%'}} />
                    </Box>
                </Grid>
                <Grid xs={12} sm={4}>
                    <Box sx={{textAlign: 'center'}}>
                        <Typography variant={'subtitle2'}>
                            {LanguageStore.currentLanguageMessages.Footer.mobile}<br/>
                            {LanguageStore.currentLanguageMessages.Footer.emailLabel} <Link href={`mailto:${LanguageStore.currentLanguageMessages.Footer.email}`} underline={'hover'}>{LanguageStore.currentLanguageMessages.Footer.email}</Link>
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Toolbar>
    )
})